/** Alpha crop and integer enlargement for the existing pixel-art source. */
export function portraitBounds(pixels:Uint8ClampedArray,width:number,height:number){
 let left=width,top=height,right=-1,bottom=-1;
 for(let y=0;y<height;y++)for(let x=0;x<width;x++)if(pixels[(y*width+x)*4+3]>8){left=Math.min(left,x);top=Math.min(top,y);right=Math.max(right,x);bottom=Math.max(bottom,y);}
 if(right<left)return {x:0,y:0,width,height};
 left=Math.max(0,left-4);top=Math.max(0,top-4);right=Math.min(width-1,right+4);bottom=Math.min(height-1,bottom+4);
 return {x:left,y:top,width:right-left+1,height:bottom-top+1};
}
export function portraitScale(width:number,height:number,availableWidth:number,availableHeight:number):number{
 const fit=Math.min(availableWidth/width,availableHeight/height);
 return fit>=1?Math.max(1,Math.floor(fit)):Math.max(.1,fit);
}
